import { Config } from '@leverege/plugin';
import Model from "../filter/GroupedTextFilterModel.js";
function suffixPrefixMatch(search, suggestion) {
  if (!search || !suggestion) {
    return null;
  }
  const suggTokens = Model.tokenize(suggestion.toLowerCase())[0];
  const tokens = Model.tokenize(Model.getLastSearch(search.toLowerCase()))[0];
  const oTokens = Model.tokenize(Model.getLastSearch(search.toLowerCase()))[0];
  // const oSuggTokens = Model.tokenize( suggestion )[0]
  const nSuggestion = suggTokens.join(' ');
  for (let i = 1; i <= tokens.length; i++) {
    if (nSuggestion.startsWith(tokens.slice(-1 * i).join(' '))) {
      const prefix = oTokens.slice(0, -1 * i).join(' ');
      const preSearch = Model.getAllButLastSearch(search);
      return `${preSearch ? `${preSearch}, ` : ''}${prefix.length > 0 ? `${prefix} ` : ''}${suggestion}`;
    }
  }
  return null;
}
function exSuffixPrefixMatch(search, suggestion) {
  if (!search || !suggestion) {
    return null;
  }
  return suffixPrefixMatch(Model.getAllButLastToken(search), suggestion);
}
function containMatch(search, suggestion) {
  if (!search || !suggestion) {
    return null;
  }
  const prefix = Model.getAllButLastToken(search);
  const lastToken = Model.getLastToken(search);
  const match = suggestion.toLowerCase().indexOf(lastToken.toLowerCase());
  if (match < 0) {
    return null;
  }
  return `${prefix ? `${prefix} ` : ''}${suggestion}`;
}
function getNewSearch(search, suggestion) {
  return suffixPrefixMatch(search, suggestion) || exSuffixPrefixMatch(search, suggestion) || containMatch(search, suggestion);
}
function noOp() {}
function searchLongEnough(token) {
  return token?.length >= Config.get('ApiSuggestions', 'minSuggestionLength', 3);
}
export default {
  suffixPrefixMatch,
  exSuffixPrefixMatch,
  containMatch,
  getNewSearch,
  noOp,
  searchLongEnough
};